import { translate, Throttle, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { SIGN_UP_STEPS } from '@gig/magic-account-types';
import { ESubmitState } from '@gig/magic-form-builder';
import { notificationService, NotificationStyle } from '@gig/magic-messaging';
import { questionnaireCheckbox } from '../../../config/checkbox-config.js';
import { singleChoice } from '../../../config/single-choice-config.js';
import { freeText } from '../../../config/free-text-config.js';
import { uiTextField } from '../../../config/ui-text-config.js';

var AnswerType;
(function (AnswerType) {
    AnswerType["FREE_TEXT"] = "FreeText";
    AnswerType["MULTIPLE_ANSWER"] = "MultipleAnswer";
    AnswerType["SINGLE_ANSWER"] = "SingleAnswer";
})(AnswerType || (AnswerType = {}));
var QuestionnaireTemplate = /** @class */ (function (_super) {
    __extends(QuestionnaireTemplate, _super);
    function QuestionnaireTemplate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.questionnairesList = [];
        _this.showQuestionnaireAnswers = false;
        _this.questionnaireFormConfig = [];
        _this.submitState = ESubmitState.PRE_SUBMIT;
        _this.formModel = {};
        return _this;
    }
    QuestionnaireTemplate.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getQuestionnaireTemplate()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    QuestionnaireTemplate.prototype.onSubmit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var submittedAnswers, questionsAndAnswers, params, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.submitState === ESubmitState.SUBMITTING) {
                            return [2 /*return*/];
                        }
                        this.submitState = ESubmitState.SUBMITTING;
                        submittedAnswers = event.detail[0];
                        questionsAndAnswers = [];
                        this.questionnaireTemplate.questions.forEach(function (question) {
                            var answers = [];
                            if (question.type === AnswerType.MULTIPLE_ANSWER) {
                                answers = submittedAnswers[question.text];
                            }
                            else {
                                answers.push(submittedAnswers[question.text]);
                            }
                            var payload = {
                                answers: answers,
                                text: question.text,
                                type: question.type,
                                isOptional: question.isOptional,
                            };
                            questionsAndAnswers.push(payload);
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        params = {
                            questionnaireId: this.questionnaireId,
                            questionsAndAnswers: questionsAndAnswers,
                        };
                        return [4 /*yield*/, magic.methods.users.getSubmitQuestionnaire(params)];
                    case 2:
                        _a.sent();
                        this.submitState = ESubmitState.POST_SUBMIT_SUCCESS;
                        notificationService.show(this.$t('questionnaire.message-success'), {
                            style: NotificationStyle.SUCCESS,
                            uniqueID: 'questionnaire-message-success',
                        });
                        this.success();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1);
                        this.submitState = ESubmitState.POST_SUBMIT_ERROR;
                        notificationService.show(this.$t('questionnaire.message-error'), {
                            style: NotificationStyle.ERROR,
                            uniqueID: 'questionnaire-message-error',
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    QuestionnaireTemplate.prototype.success = function () {
        return;
    };
    QuestionnaireTemplate.prototype.onChange = function (event) {
        var form = event.detail[0].form;
        Object.assign(this.formModel, form);
    };
    QuestionnaireTemplate.prototype.getQuestionnaireTemplate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, components, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, magic.methods.users.getQuestionnaireTemplate({
                                questionnaireTemplateId: this.templateId,
                            })];
                    case 1:
                        _a.questionnaireTemplate =
                            _c.sent();
                        this.showQuestionnaireAnswers = true;
                        components = [];
                        if (!(this.showQuestionnaireAnswers &&
                            this.questionnaireTemplate.questions)) return [3 /*break*/, 3];
                        this.questionnaireTemplate.questions.forEach(function (question, index) {
                            components.push(uiTextField(index, question.text));
                            if (question.type === AnswerType.MULTIPLE_ANSWER) {
                                components.push(questionnaireCheckbox(question));
                            }
                            else if (question.type === AnswerType.SINGLE_ANSWER) {
                                components.push(singleChoice(question));
                            }
                            else if (question.type === AnswerType.FREE_TEXT) {
                                components.push(freeText(question));
                            }
                        });
                        _b = this;
                        return [4 /*yield*/, this.coreXQuestionnaireFormConfig(components)];
                    case 2:
                        _b.questionnaireFormConfig =
                            _c.sent();
                        _c.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    QuestionnaireTemplate.prototype.coreXQuestionnaireFormConfig = function (components) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, [
                        {
                            name: 'questionnaire',
                            path: SIGN_UP_STEPS.STEP_1,
                            components: components,
                            nextButton: {
                                text: translate('agco-pep-block-modal.submit-button'),
                                alwaysEnabled: false,
                            },
                        },
                    ]];
            });
        });
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], QuestionnaireTemplate.prototype, "templateId", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], QuestionnaireTemplate.prototype, "questionnaireId", void 0);
    __decorate([
        Emit('success'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], QuestionnaireTemplate.prototype, "success", null);
    __decorate([
        Throttle(500),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [CustomEvent]),
        __metadata("design:returntype", void 0)
    ], QuestionnaireTemplate.prototype, "onChange", null);
    QuestionnaireTemplate = __decorate([
        Component({
            name: 'corex-questionnaire',
        })
    ], QuestionnaireTemplate);
    return QuestionnaireTemplate;
}(Mixins(MagicConfigMixin)));

export default QuestionnaireTemplate;
